import React from "react";
import { Typography } from "@mui/material";

const FieldViewVersions = ({ title, versions }) => (
  <>
    <Typography variant="caption">{title}</Typography>
    {versions &&
      versions.map(({ key, value }) => (
        <Typography variant="body2" component="div" noWrap key={key}>
          {`${key} - ${value}`}
        </Typography>
      ))}
  </>
);

export default FieldViewVersions;
